/**
   * @ngdoc directive
   * @name adjust.directive:roundNumber
   * @scope
   * @restrict E
   *
   * @description
   * Rounds off the number at provided limit
   * displays symbol '<' or '>' with the number exceding the limit
   * and shows a popover on hover with actual value
   *
   * @param {Integer} number actual number
   * @param {Integer} limit max limit on which to round-off
   * @param {Integer} fraction decimel places value
   *
   */
function roundNumber() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    controller: 'RoundNumberController',
    controllerAs: 'vm',
    bindToController: {
      number: '@',
      limit: '@?',
      fraction: '@?'
    },
    template: require('./round-number.html')
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:RoundNumberController
   *
   * @description
   * All the functionality of the {@link adjust.directive:roundNumber roundNumber} directive
   *
   */
function RoundNumberController() {
  'ngInject';
  var vm = this;

  vm.limit = angular.isDefined(vm.limit) ? vm.limit : 1000;
  vm.fraction = angular.isDefined(vm.fraction) ? vm.fraction : 1;
}

export { RoundNumberController, roundNumber };
